const state = {
  showTooltip: null,
  hoveringTooltip: null,
};

export default state;
